import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-dropdown-empty-state',
  templateUrl: './evaluation-dropdown-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, HeadingComponent],
})
export class EvaluationDropdownEmptyStateComponent {}
